<template>
  <div>
    <alert-http :error="error" v-if="isAlertHttp" @close="$emit('close', $event)" />
  </div>

</template>

<script>
import alertHttp from "@/_components/layouts/alert-http"
//add additional error types

export default {
  name: 'AlertTemplate',
  props : {
    error : {type:Error, default:() => null}
  },
  components : {alertHttp},
  computed : {
    isAlertHttp()
    {
      //debugger;
      return !!this.error && !!this.error.status;
    }
  },
  data()
  {
    return {
    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
div
{
  width:100%;
}
</style>
